module.exports = __webpack_public_path__ + "img/ywAward-b.6e2ad508.png";